import { InjectionToken } from '@angular/core';
import type { ExtendedScrollToOptions } from '@angular/cdk/scrolling';
import type { HorizontalScrollDirection } from '../../domain/direction';
import type { ScrollableDirective } from './scrollable.directive';

export const SCROLL_EDGE_THRESHOLD = 5;

export const SCROLL_OPTIONS_STRATEGY =
  new InjectionToken<ScrollOptionsStrategy>('ScrollOptionsStrategy');

export interface HorizontalScrollPosition {
  left: number;
  right: number;
}

export interface ScrollOptionsStrategy {
  /** Attaches this position strategy to an overlay. */
  scroll(direction: HorizontalScrollDirection,
    scrollable: ScrollableDirective,
    positions?: Array<HorizontalScrollPosition>): ExtendedScrollToOptions;
}
